import { ThemeContext } from '@hzero-front-ui/core';
export { getPrimaryColor } from '@hzero-front-ui/core/lib/utils';
export { getThemeData as getRequiredData, getStyleSheetTarget, getAsset, hexToRgbaColor } from '@hzero-front-ui/core';
export function _getAsset(name) {
  var _ref = (ThemeContext || {})._currentValue || {},
    _ref$originTheme = _ref.originTheme,
    originTheme = _ref$originTheme === void 0 ? {} : _ref$originTheme;
  var _originTheme$images = originTheme.images,
    assets = _originTheme$images === void 0 ? {} : _originTheme$images;
  return assets[name];
}